// Module
var code = "<div href=# ng-click=$ctrl.downloadRecos()><img class=icon-download src=https://res.cloudinary.com/dbwijvnzn/image/upload/v1743573927/attachments/Group_10244_afxggt.png><label>Download</label></div>";
// Exports
module.exports = code;